<script lang="ts" setup>
import { useModalStore } from "@/stores/modals/modals.store";

import LibraryDetailItem from "@/views/Library/LibraryDetailItem.vue";

defineProps<{
  includedPhases?: Array<number>;
  material: any;
  parentName?: string | null;
}>();

const modals = useModalStore();

const onClick = (material: any) => {
  modals.open("InspectMaterial", { material: material, parentName: material.name }, { stackable: true });
};
</script>

<template>
  <LibraryDetailItem
    :material="material"
    :included-phases="includedPhases"
    :parent-name="parentName"
    @on-click="onClick"
    @back="modals.closeTop()" />
</template>
